// export const baseUrl = "https://misasminibackend.singspire.com.ng/api";
// export const baseUrl = "http://127.0.0.1:8000/api";
export const baseUrl = "https://peacefulmd-backend.misas.ng/api";